import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { Gender } from "@/gql/graphql";
import { bookingMessages } from "@/app/Bookings/Messages/bookingMessages";

export function BookingGenderInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  return (
    <SelectInput
      options={[
        {
          label: bookingMessages.genderLabel,
          options: [
            { label: bookingMessages.gender[Gender.Male], value: Gender.Male },
            {
              label: bookingMessages.gender[Gender.Female],
              value: Gender.Female,
            },
            {
              label: bookingMessages.gender[Gender.Other],
              value: Gender.Other,
            },
          ],
        },
      ]}
      {...props}
    />
  );
}
